export const breakpoints = {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 576, 768, 1200, 1600],
    maxWidths: [540, 540, 720, 1366, 1540],
};